import {MsalProvider} from "./ms";
import {getPublicCredentials} from "../../utils/environment";

const {ms_client_id} = getPublicCredentials();

const OauthProviders = ({children}: {children?: React.ReactNode}) => {
  return (
    // Used for Microsoft file picker
    <MsalProvider clientId={ms_client_id}>{children}</MsalProvider>
  );
};

export default OauthProviders;
